<mat-toolbar class="app-navbar">
  <button
    type="button"
    aria-label="Alternar menú lateral"
    matIconButton
    class="app-navbar__toggle"
    (click)="menuLateral.toggle()"
  >
    <mat-icon aria-hidden="true">menu</mat-icon>
  </button>

  <app-select-material
    class="app-navbar__fleet"
    [class.app-navbar__fleet--single]="isSingleFleetSelected()"
    label="Flota"
    [multiple]="true"
    [items]="fleetOptions()"
    [loading]="fleetOptionsLoading()"
    fieldId="id"
    fieldName="name"
    placeholder="Seleccione una flota"
    [value]="fleetSelectValue()"
    (valueChange)="onFleetChange($event)"
  />

  <span class="app-navbar__spacer"></span>

  <app-menu-info-user class="app-navbar__user" />

  <button
    matIconButton
    class="app-navbar__logout"
    aria-label="Cerrar sesión"
    matTooltip="Cerrar sesión"
    matTooltipPosition="below"
    (click)="logout()"
  >
    <mat-icon aria-hidden="true">logout</mat-icon>
  </button>
</mat-toolbar>
